import { render, staticRenderFns } from "./riskAssessment.vue?vue&type=template&id=3217c830"
import script from "./riskAssessment.vue?vue&type=script&lang=js"
export * from "./riskAssessment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports